import React, { useState, useEffect, useContext } from "react";
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import globalContext from "./globalContext";

const Snack = (props) => {
    const gContext = useContext(globalContext)
    const [open, setOpen] = useState({
        shouldOpen: false,
        msg: ""
    });

    useEffect(() => {
        handleSnack(gContext.snack.open.msg, gContext.snack.open.shouldOpen)
    }, [gContext.snack.open])

    function handleSnack(msg, shouldOpen) {
        setOpen({
            msg: msg,
            shouldOpen: shouldOpen
        });
    }

    return (
        <Snackbar
            open={open.shouldOpen}
            autoHideDuration={2000}
            message={open.msg}
            onClose={() => { handleSnack('', false) }}
            action={
                <Button color="secondary" size="small" onClick={() => { handleSnack('', false) }}>
                    CLOSE ME
                </Button>
            }
        />
    )
}

export default Snack;